module.exports = __webpack_public_path__ + "img/iconfinder-icon-image.eb1ec22b.jpg";